import { capitalize } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/utils';

const buildName = (prefix, name) => {
  const upperFirstLetter = capitalize(name);

  return `${prefix}${upperFirstLetter}`;
};

export const buildStyles = (options, prefix, styleObjBuilder) => {
  return options.reduce((acc, curr) => {
    acc[buildName(prefix, curr.name)] = styleObjBuilder(curr.config);

    return acc;
  }, {});
};

export const buildStyleObj = (name, config) => {
  return {
    name,
    config,
  };
};

export const buildStylesFromArray = (array, prefix, styleObjBuilder) => {
  return buildStyles(array.map((size) => {
    return buildStyleObj(size, size);
  }), prefix, styleObjBuilder);
};

export const matchStyle = (classes, options, prefix, selected) => {
  return options.reduce((acc, curr) => {
    acc[classes[buildName(prefix, curr)]] = selected === curr;

    return acc;
  }, {});
};

export const applyStyle = (classes, prefix, selected) => {
  return classes[buildName(prefix, selected)];
};
